import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const u = params.get("u") || "";
  const t = params.get("t") || "";
  const [state, setState] = useState("confirm"); // confirm | done | resubscribed | error
  const [busy, setBusy] = useState(false);

  const doUnsub = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/newsletter/unsubscribe`, { user_id: u, token: t });
      setState("done");
    } catch { setState("error"); }
    finally { setBusy(false); }
  };

  const doResub = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/newsletter/resubscribe`, { user_id: u, token: t });
      setState("resubscribed");
    } catch { setState("error"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-bone grid place-items-center px-6" data-testid="unsubscribe-page">
      <div className="max-w-md w-full text-center">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-gold">In His Image Movement Ministries</span>
        {state === "confirm" && (
          <>
            <h1 className="font-serif text-4xl tracking-tight mt-4">Unsubscribe from emails?</h1>
            <p className="font-sans text-charcoal/60 mt-3">You'll stop receiving newsletters and announcements. You can resubscribe anytime.</p>
            <button onClick={doUnsub} disabled={busy} data-testid="unsubscribe-confirm" className="mt-8 bg-charcoal text-bone px-8 py-3 font-mono text-xs uppercase tracking-widest hover:bg-rust transition-colors disabled:opacity-50">
              {busy ? "Please wait…" : "Yes, unsubscribe me"}
            </button>
          </>
        )}
        {state === "done" && (
          <>
            <h1 className="font-serif text-4xl tracking-tight mt-4">You're unsubscribed</h1>
            <p className="font-sans text-charcoal/60 mt-3">You will no longer receive newsletters. Changed your mind?</p>
            <button onClick={doResub} disabled={busy} data-testid="resubscribe-btn" className="mt-8 border border-charcoal/30 px-8 py-3 font-mono text-xs uppercase tracking-widest hover:bg-sand transition-colors disabled:opacity-50">
              Resubscribe
            </button>
          </>
        )}
        {state === "resubscribed" && (
          <>
            <h1 className="font-serif text-4xl tracking-tight mt-4">Welcome back</h1>
            <p className="font-sans text-charcoal/60 mt-3">You're subscribed again and will receive our updates.</p>
          </>
        )}
        {state === "error" && (
          <>
            <h1 className="font-serif text-4xl tracking-tight mt-4">Link invalid</h1>
            <p className="font-sans text-charcoal/60 mt-3">This unsubscribe link is invalid or expired.</p>
          </>
        )}
      </div>
    </div>
  );
}
